/** Shared by the picked list row and the sticky summary so one morphs into the other. */
export const SELECTED_SERVICE_TRANSITION_NAME = 'booking-selected-service';

export function findVisibleServiceRow(templateId: string) {
  const rows = document.querySelectorAll<HTMLElement>(
    `[data-test="service-list"] [data-template-id="${CSS.escape(templateId)}"]`,
  );
  return Array.from(rows).find((row) => row.getClientRects().length > 0);
}

/**
 * Runs `update` (which must commit synchronously, e.g. via flushSync) inside a
 * view transition that morphs the picked service row into the sticky summary,
 * or back. Returns false when the browser can't animate it (no View
 * Transitions, reduced motion), so the caller applies the update itself.
 */
export function morphSelectedService(templateId: string, update: () => void) {
  if (
    typeof document.startViewTransition !== 'function' ||
    window.matchMedia('(prefers-reduced-motion: reduce)').matches
  ) {
    return false;
  }

  const tagRow = () => {
    const row = findVisibleServiceRow(templateId);
    row?.style.setProperty('view-transition-name', SELECTED_SERVICE_TRANSITION_NAME);
    return row;
  };

  // Collapsing: the row is on screen now. Expanding: it appears after update.
  const rowBefore = tagRow();
  const transition = document.startViewTransition(() => {
    rowBefore?.style.removeProperty('view-transition-name');
    update();
    if (!rowBefore) tagRow();
  });
  void transition.finished.finally(() =>
    findVisibleServiceRow(templateId)?.style.removeProperty(
      'view-transition-name',
    ),
  );
  return true;
}
